// rooms images

import dcExeImage1 from './assets/img/rooms/dcExecutiveSlike/1.jpg';
import dreamImgSmall from './assets/img/rooms/dreamApartmentsSlike/1.jpg';
import imageBannerDCExe from './assets/img/room.jpg';
import imageBannerDreamAp from './assets/img/roomS.jpg';

import Icon from '@mdi/react';
import { mdiWashingMachine } from '@mdi/js';
import { FaBicycle } from 'react-icons/fa';

// import { useTranslation } from 'react-i18next';

  


// import icons
import {
  FaWifi,
  FaBath,
  FaParking,
  FaSnowflake,
  FaUtensils,
  FaFire,
  FaHome,
  FaTree,
  FaSmokingBan,
} from 'react-icons/fa';
// const [t, i18n] = useTranslation("global");

const imagesDCExecutive = [];
for (let i = 1; i <= 28; i++) {
  imagesDCExecutive.push(require(`./assets/img/rooms/dcExecutiveSlike/${i}.jpg`));
}

const imagesDreamApartments = [];
for (let i = 1; i <= 29; i++) {
  imagesDreamApartments.push(require(`./assets/img/rooms/dreamApartmentsSlike/${i}.jpg`));
}

export const roomData = [
  {
    id: 1,
    name: 'Dream Apartments',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit.Ea placeat eos sed voluptas unde veniam eligendi a. Quaerat molestiae hic omnis temporibus quos consequuntur nam voluptatum ea accusamus, corrupti nostrum eum placeat quibusdam quis beatae quae labore earum architecto aliquid debitis.',
      // t("dreamPageText.description1"),
    facilities: [
      { name: 'Fast free WiFi (89 Mbps)', icon: <FaWifi /> },
      { name: 'Entire apartment', icon: <FaHome /> },
      { name: 'Bath', icon: <FaBath /> },
      { name: 'Parking Space', icon: <FaParking /> },
      { name: 'Non Smoking', icon: <FaSmokingBan /> },
      { name: 'A.C.', icon: <FaSnowflake /> },
      { name: 'Kitchen', icon: <FaUtensils /> },
      { name: 'BBQ Facilities', icon: <FaFire /> },
      { name: 'Backyard', icon: <FaTree /> },
      // { name: 'Coffee', icon: <FaCoffee /> },
      { name: 'Bike Rental', icon: <FaBicycle /> },
      { name: 'Washing Machine', icon: <Icon path={mdiWashingMachine} size={1.5} /> },
    ],
    size: 78,
    maxPerson: 5,
    // price: 115,
    phoneNumber: '+381 658079191',
    linkMape : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2809.3183257083447!2d19.807997376092096!3d45.24135537107126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b102c2999fb27%3A0x9ba112aea55209f5!2sAdi%20Endrea%2030%2C%20Novi%20Sad%20406331%2C%20Serbia!5e0!3m2!1sen!2smk!4v1704808017346!5m2!1sen!2smk',
    image: dreamImgSmall,
    adresa: 'Adi Endrea 30',
    imageLg: imagesDreamApartments,
    imageLGBanner: imageBannerDreamAp,
  },
  {
    id: 2,
    name: 'DC Executive Homes',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit.Ea placeat eos sed voluptas unde veniam eligendi a. Quaerat molestiae hic omnis temporibus quos consequuntur nam voluptatum ea accusamus, corrupti nostrum eum placeat quibusdam quis beatae quae labore earum architecto aliquid debitis.',
    facilities: [
      { name: 'Fast free WiFi (89 Mbps)', icon: <FaWifi /> },
      { name: 'Entire apartment', icon: <FaHome /> },
      { name: 'Bath', icon: <FaBath /> },
      { name: 'Parking Space', icon: <FaParking /> },
      { name: 'Non Smoking', icon: <FaSmokingBan /> },
      { name: 'A.C.', icon: <FaSnowflake /> },
      { name: 'Kitchen', icon: <FaUtensils /> },
      { name: 'BBQ Facilities', icon: <FaFire /> },
      { name: 'Backyard', icon: <FaTree /> },
      { name: 'Bike Rental', icon: <FaBicycle /> },
      { name: 'Washing Machine', icon: <Icon path={mdiWashingMachine} size={1.5} /> },
    ],
    size: 75,
    maxPerson: 7,
    // price: 220,
    phoneNumber: '+381 646106752',
    linkMape : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2809.237513835913!2d19.815624676092128!3d45.242989671071236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b1030033b0da9%3A0x60aa57c31ecadfa!2sMilutina%20Boji%C4%87a%2012%2C%20Novi%20Sad%20406022%2C%20Serbia!5e0!3m2!1sen!2smk!4v1704808809912!5m2!1sen!2smk',
    // image: dcImageSmall,
    image:dcExeImage1,
    adresa: 'Milutina Bojića 12',
    // imageLg: [dcExeImage1, Room2ImgLg],
    imageLg:imagesDCExecutive,
    imageLGBanner: imageBannerDCExe,
  },
];
